import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, Heart, Compass, Users, ArrowRight, Target, Eye, CheckCircle2, Quote, Star, Phone, ChevronRight, Sparkles, Building2, Globe2 } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "../components/GuideBits";
import { useContent } from "../context/ContentContext";
import { usePageMeta } from "../hooks/usePageMeta";

const TX = {
  en: {
    crumb: "About Us",
    title: "About Fly Jannah",
    sub: "Your trusted Hajj & Umrah travel partner from Bangladesh.",
    stats: [["1000+", "Happy Pilgrims"], ["100%", "Success Rate"], ["4.9", "Client Rating"], ["5+", "Years Experience"]],
    story_eye: "Who We Are",
    story_title: "Our Story",
    story_body:
      "Fly Jannah Tours & Travels was founded with a single mission — to make the sacred journey to Makkah and Madinah accessible, comfortable and spiritually fulfilling for every Muslim. Over the years we have served thousands of pilgrims with premium accommodations, dedicated visa support and heartfelt guidance from experienced scholars.",
    mission_t: "Our Mission",
    mission: "To provide a comprehensive, all-in-one Hajj & Umrah experience — combining comfort, convenience and complete peace of mind for every pilgrim.",
    vision_t: "Our Vision",
    vision: "To be the most trusted pilgrimage travel company, known for excellence, transparency and heartfelt service to the guests of Allah.",
    why_eye: "Why Choose Us",
    why_title: "Why Choose Fly Jannah",
    team_eye: "Our Guides",
    team_title: "Our Scholars & Guides",
    team_sub: "Esteemed scholars well-versed in the teachings of Islam and the rituals of Hajj & Umrah.",
    team: [
      { n: "Golam Rabbii", r: "Founder & Managing Director", d: "Fly Jannah Tours & Travels" },
      { n: "Mufti Abdul Karim", r: "Chief Hajj Guide", d: "Kamil (Hadith), 12 Hajj seasons" },
      { n: "Maulana Shafiqur Rahman", r: "Imam & Khatib", d: "B.A (Hons), M.A (DU)" },
      { n: "Dr. Mahmudul Hasan", r: "Associate Professor", d: "Dept. of Islamic Studies" },
    ],
    testi_eye: "Testimonials",
    testi_title: "What Our Pilgrims Say",
    testi_sub: "Real stories from pilgrims who trusted us with their sacred journey.",
    cta_title: "Ready to Begin Your Sacred Journey?",
    cta_sub: "Let Fly Jannah handle every detail so you can focus entirely on your ibadah.",
    call: "Call Us Now",
    book: "Book a Package",
  },
  bn: {
    crumb: "আমাদের সম্পর্কে",
    title: "ফ্লাই জান্নাহ সম্পর্কে",
    sub: "বাংলাদেশ থেকে আপনার বিশ্বস্ত হজ ও উমরাহ ভ্রমণ সঙ্গী।",
    stats: [["১০০০+", "সন্তুষ্ট হাজী"], ["১০০%", "সাফল্যের হার"], ["৪.৯", "ক্লায়েন্ট রেটিং"], ["৫+", "বছরের অভিজ্ঞতা"]],
    story_eye: "আমরা কারা",
    story_title: "আমাদের গল্প",
    story_body:
      "ফ্লাই জান্নাহ ট্যুরস অ্যান্ড ট্রাভেলস একটি লক্ষ্য নিয়ে প্রতিষ্ঠিত — মক্কা ও মদিনার পবিত্র সফরকে প্রতিটি মুসলমানের জন্য সহজলভ্য, আরামদায়ক ও আধ্যাত্মিকভাবে পরিপূর্ণ করা। বছরের পর বছর আমরা হাজার হাজার হাজীকে প্রিমিয়াম আবাসন, নিবেদিত ভিসা সহায়তা ও অভিজ্ঞ আলেমদের আন্তরিক দিকনির্দেশনায় সেবা দিয়ে আসছি।",
    mission_t: "আমাদের লক্ষ্য",
    mission: "প্রতিটি হাজীর জন্য আরাম, সুবিধা ও সম্পূর্ণ প্রশান্তির সমন্বয়ে একটি পরিপূর্ণ, এক-ছাদের-নিচে হজ ও উমরাহ অভিজ্ঞতা প্রদান করা।",
    vision_t: "আমাদের রূপকল্প",
    vision: "উৎকর্ষ, স্বচ্ছতা ও আল্লাহর মেহমানদের প্রতি আন্তরিক সেবার জন্য পরিচিত সবচেয়ে বিশ্বস্ত পবিত্র ভ্রমণ প্রতিষ্ঠান হওয়া।",
    why_eye: "কেন আমরা",
    why_title: "কেন ফ্লাই জান্নাহ বেছে নেবেন",
    team_eye: "আমাদের গাইড",
    team_title: "আমাদের আলেম ও গাইডগণ",
    team_sub: "ইসলামের শিক্ষা এবং হজ ও উমরাহর আনুষ্ঠানিকতায় পারদর্শী সম্মানিত আলেমগণ।",
    team: [
      { n: "গোলাম রাব্বী", r: "প্রতিষ্ঠাতা ও ব্যবস্থাপনা পরিচালক", d: "ফ্লাই জান্নাহ ট্যুরস অ্যান্ড ট্রাভেলস" },
      { n: "মুফতি আব্দুল করিম", r: "প্রধান হজ গাইড", d: "কামিল (হাদিস), ১২টি হজ মৌসুম" },
      { n: "মাওলানা শফিকুর রহমান", r: "ইমাম ও খতিব", d: "বি.এ (অনার্স), এম.এ (ঢাবি)" },
      { n: "ড. মাহমুদুল হাসান", r: "সহযোগী অধ্যাপক", d: "ইসলামিক স্টাডিজ বিভাগ" },
    ],
    testi_eye: "প্রশংসাপত্র",
    testi_title: "আমাদের হাজীরা যা বলেন",
    testi_sub: "যারা তাদের পবিত্র সফরে আমাদের উপর আস্থা রেখেছেন, তাদের সত্যিকারের গল্প।",
    cta_title: "আপনার পবিত্র সফর শুরু করতে প্রস্তুত?",
    cta_sub: "প্রতিটি বিষয় ফ্লাই জান্নাহর হাতে ছেড়ে দিন, আপনি শুধু ইবাদতে মনোযোগ দিন।",
    call: "এখনই কল করুন",
    book: "প্যাকেজ বুক করুন",
  },
};

const whyIcons = [Building2, Globe2, Sparkles, Compass];
const initials = (n) => n.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("");

const Heading = ({ eyebrow, title, sub, center = true, light = false }) => (
  <Reveal className={center ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
    <span className={`eyebrow ${light ? "text-jannah-gold-light" : "text-jannah-green"}`}>{eyebrow}</span>
    <h2 className={`mt-3 text-4xl md:text-5xl font-bold ${light ? "text-white" : "text-jannah-ink"}`}>{title}</h2>
    {sub && <p className={`mt-4 text-base md:text-lg ${light ? "text-white/75" : "text-jannah-ink/65"}`}>{sub}</p>}
    <div className={`gold-divider mt-5 ${center ? "mx-auto" : ""}`} />
  </Reveal>
);

const About = () => {
  const { t, lang } = useLang();
  usePageMeta({ title: "About Us", description: "Learn about Fly Jannah Tours & Travels — a trusted Hajj & Umrah agency in South Banasree, Dhaka, with 1000+ happy pilgrims, experienced scholars and a 100% success record." });
  const { IMAGES, TESTIMONIALS, CONTACT, TEAM, settings } = useContent();
  const c = TX[lang];

  return (
    <div data-testid="about-page">
      {/* Banner + floating stats */}
      <section className="relative overflow-hidden bg-jannah-green-dark" data-testid="about-banner">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.aboutSecondary})` }} />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-36 md:pt-28 md:pb-40">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="flex items-center gap-2 text-sm text-white/70">
            <Link to="/" className="hover:text-white">{t.nav.home}</Link> <ChevronRight size={14} /> <span className="text-jannah-gold-light">{c.crumb}</span>
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1, duration: 0.7 }} className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-white">{c.title}</motion.h1>
          <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.7 }} className="mt-4 text-base md:text-lg text-white/80 max-w-xl">{c.sub}</motion.p>
        </div>
      </section>
      <div className="relative z-10 max-w-7xl mx-auto px-6 -mt-20">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35, duration: 0.7 }} className="grid grid-cols-2 lg:grid-cols-4 bg-white rounded-2xl shadow-2xl border border-jannah-sand overflow-hidden" data-testid="about-stats">
          {[[`${settings.stats?.pilgrims ?? 1000}+`, c.stats[0][1]], [`${settings.stats?.success ?? 100}%`, c.stats[1][1]], [`${settings.stats?.rating ?? 4.9}`, c.stats[2][1]], [`${settings.stats?.years ?? 5}+`, c.stats[3][1]]].map(([v, l], i) => (
            <div key={i} className="py-8 px-4 text-center border-b lg:border-b-0 border-r last:border-r-0 [&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r border-jannah-sand">
              <div className="text-4xl md:text-5xl font-bold text-jannah-green">{v}</div>
              <div className="mt-1 text-sm text-jannah-ink/60">{l}</div>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Story */}
      <section className="pt-24 pb-24 bg-white" data-testid="about-story">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <Reveal className="relative">
            <img src={IMAGES.aboutMain} alt="Makkah" className="rounded-2xl w-[88%] h-[460px] object-cover shadow-xl" />
            <motion.img initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3, duration: 0.7 }} src={IMAGES.heroSlides[1]} alt="Madinah" className="absolute -bottom-10 right-0 w-[48%] h-56 object-cover rounded-2xl border-[6px] border-white shadow-2xl" />
            <div className="absolute -top-5 -left-5 w-28 h-28 rounded-full bg-jannah-gold/20 blur-2xl" />
          </Reveal>
          <Reveal i={1}>
            <Heading eyebrow={c.story_eye} title={c.story_title} center={false} />
            <p className="mt-6 text-jannah-ink/70 leading-relaxed text-base md:text-lg">{c.story_body}</p>
            <div className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-4">
              {t.about.points.map((p, i) => (
                <div key={i} className="flex items-start gap-3 text-sm text-jannah-ink/80">
                  <CheckCircle2 size={18} className="text-jannah-green shrink-0 mt-0.5" /> {p}
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-24 grid md:grid-cols-2 gap-6">
          {[{ Icon: Target, t: c.mission_t, b: c.mission, dark: true }, { Icon: Eye, t: c.vision_t, b: c.vision, dark: false }].map((m, i) => (
            <Reveal key={i} i={i}>
              <div className="h-full rounded-2xl bg-jannah-cream p-10 border border-jannah-sand hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center text-white ${m.dark ? "bg-jannah-green" : "bg-jannah-gold"}`}><m.Icon size={26} /></div>
                <h3 className="mt-6 text-2xl md:text-3xl font-bold text-jannah-green">{m.t}</h3>
                <p className="mt-3 text-jannah-ink/70 leading-relaxed text-base md:text-lg">{m.b}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Why choose */}
      <section className="section-pad bg-jannah-cream" data-testid="about-why">
        <div className="max-w-7xl mx-auto px-6">
          <Heading eyebrow={c.why_eye} title={c.why_title} sub={t.sec.why_sub} />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {t.why.map((w, i) => {
              const Icon = whyIcons[i];
              return (
                <Reveal key={i} i={i}>
                  <div className="group h-full bg-white rounded-2xl p-8 border border-jannah-sand hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300">
                    <div className="w-14 h-14 rounded-full bg-jannah-green/10 flex items-center justify-center group-hover:bg-jannah-green transition-colors"><Icon size={26} className="text-jannah-green group-hover:text-white transition-colors" /></div>
                    <h3 className="mt-6 text-xl font-bold text-jannah-ink">{w.title}</h3>
                    <p className="mt-3 text-sm text-jannah-ink/65 leading-relaxed">{w.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section-pad bg-white" data-testid="about-team">
        <div className="max-w-7xl mx-auto px-6">
          <Heading eyebrow={c.team_eye} title={c.team_title} sub={c.team_sub} />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {TEAM.map((m, i) => (
              <Reveal key={i} i={i}>
                <div className="group rounded-2xl overflow-hidden border border-jannah-sand bg-white hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-300">
                  <div className="relative h-44 bg-jannah-green-dark">
                    <div className="absolute inset-0 pattern-overlay opacity-40 overflow-hidden" />
                    <div className="absolute inset-x-0 -bottom-16 flex justify-center">
                      {m.image ? (
                        <img src={m.image} alt={m.n_en} className="w-32 h-32 rounded-full object-cover border-[6px] border-white shadow-xl group-hover:scale-105 transition-transform" />
                      ) : (
                        <div className="w-32 h-32 rounded-full bg-gradient-to-br from-jannah-gold to-jannah-gold-light border-[6px] border-white flex items-center justify-center text-3xl font-bold text-white shadow-xl group-hover:scale-105 transition-transform">{initials(m.n_en)}</div>
                      )}
                    </div>
                  </div>
                  <div className="pt-20 pb-8 px-6 text-center">
                    <h3 className="text-xl font-bold text-jannah-ink">{lang === "en" ? m.n_en : m.n_bn}</h3>
                    <div className="mt-1 text-jannah-gold font-semibold text-sm">{lang === "en" ? m.r_en : m.r_bn}</div>
                    <div className="mt-1 text-xs text-jannah-ink/55">{lang === "en" ? m.d_en : m.d_bn}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section-pad bg-jannah-cream" data-testid="about-testimonials">
        <div className="max-w-7xl mx-auto px-6">
          <Heading eyebrow={c.testi_eye} title={c.testi_title} sub={c.testi_sub} />
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {TESTIMONIALS.map((r, i) => (
              <Reveal key={r.id} i={i}>
                <div className="h-full flex flex-col rounded-2xl bg-white p-7 border border-jannah-sand hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                  <Quote size={30} className="text-jannah-gold" />
                  <div className="mt-4 flex gap-0.5">{Array.from({ length: r.rating }).map((_, k) => <Star key={k} size={14} className="fill-jannah-gold text-jannah-gold" />)}</div>
                  <p className="mt-4 text-sm text-jannah-ink/75 leading-relaxed flex-1">“{lang === "en" ? r.text_en : r.text_bn}”</p>
                  <div className="mt-6 flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full bg-jannah-green text-white font-bold flex items-center justify-center">{r.name[0]}</div>
                    <div>
                      <div className="font-bold text-jannah-ink text-sm">{r.name}</div>
                      <div className="text-xs text-jannah-ink/55">{lang === "en" ? r.location_en : r.location_bn}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative overflow-hidden" data-testid="about-cta">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.ctaBg})` }} />
        <div className="absolute inset-0 bg-jannah-green-dark/85" />
        <div className="relative max-w-4xl mx-auto px-6 py-24 text-center">
          <Reveal>
            <h2 className="text-4xl md:text-5xl font-bold text-white">{c.cta_title}</h2>
            <p className="mt-4 text-white/80 text-base md:text-lg">{c.cta_sub}</p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
              <a href={`tel:${CONTACT.phone2}`} className="inline-flex items-center gap-2 px-7 py-4 rounded-full btn-gold font-bold uppercase tracking-wider text-sm transition-colors" data-testid="about-call-btn"><Phone size={16} /> {c.call}</a>
              <Link to="/umrah" className="inline-flex items-center gap-2 px-7 py-4 rounded-md bg-white text-jannah-green-dark font-bold uppercase tracking-wider text-sm hover:bg-jannah-gold hover:text-white transition-colors shadow-lg" data-testid="about-book-btn">{c.book} <ArrowRight size={16} /></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default About;
